import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  text: {
    id: 'pages.error.text',
    defaultMessage: 'WHOOPS, WE ARE SORRY, SOMETHING HAS<br />GONE WRONG… START AGAIN AT OUR<br />',
  },
  homepage: {
    id: 'pages.error.homepage',
    defaultMessage: 'Homepage',
  },
  contact: {
    id: 'pages.error.contact',
    defaultMessage: 'Contact Us',
  },
  or: {
    id: 'pages.error.or',
    defaultMessage: 'or',
  },
});



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/messages.js